import EventEmitter from "common/utils/EventEmitter.js";
import LiveStreaming from "./LiveStreaming";
import { RequestManager } from "./RequestManager";
import { USER_ROLE } from "./enums/LiveStreamingEnums";
import LoggerService from "./LoggerService";

export default class VideoStateManager {
  static mapping = {};
  static videoStates = {};

  static CONNECTION_STATES = {
    Connecting: "Connecting",
    Connected: "Connected",
    Disconnected: "Disconnected",
    Closed: "Closed"
  };

  static MEDIA_TYPE = {
    WEBCAM: 0,
    SCREENSHARE: 1
  };

  static init() {
    EventEmitter.on("UPDATE_CONNECTION_STATE", VideoStateManager.stateChangeListener);
  }

  static getVideoId(peerId, mediaType) {
    return peerId + mediaType;
  }

  static async stateChangeListener(data) {
    let { roomId, peerId, state, requestedStreams, connectionDuration } = data;

    if (
      state == VideoStateManager.CONNECTION_STATES.Connected ||
      state == VideoStateManager.CONNECTION_STATES.Closed
    ) {

      if (state == VideoStateManager.CONNECTION_STATES.Connected) {
        LoggerService.info(
          LoggerService.MODULE.STREAMING,
          `[Streaming] peerId: ${peerId} [connectionState: ${state}] [duration: ${connectionDuration/1000}s]`
        );
      } else {
        LoggerService.info(
          LoggerService.MODULE.STREAMING,
          `[Streaming] peerId: ${peerId} [connectionState: ${state}]`
        );
      }


      if (requestedStreams.webcam) {
        VideoStateManager.updateState(roomId, peerId, VideoStateManager.MEDIA_TYPE.WEBCAM, state);
      }

      if (requestedStreams.screen) {
        VideoStateManager.updateState(
          roomId,
          peerId,
          VideoStateManager.MEDIA_TYPE.SCREENSHARE,
          state
        );
      }
    }

    const config = {
      userId: roomId,
      requestedStreams
    };

    if (state == VideoStateManager.CONNECTION_STATES.Connected) {
      if (LiveStreaming.config.userRole == USER_ROLE.VIEWER) {
        RequestManager.clearConnectionTimer(config);
      }
    } else if (state == VideoStateManager.CONNECTION_STATES.Closed) {
      await RequestManager.createRetryRequest(config);
    }
  }

  static updateState(roomId, peerId, mediaType, state) {
    let videoId = VideoStateManager.getVideoId(peerId, mediaType);

    const isConnected = state == this.CONNECTION_STATES.Connected;

    VideoStateManager.videoStates[videoId] = isConnected;
    VideoStateManager.updateConnectionStatus(roomId, peerId, videoId, mediaType, state);
  }

  static updateConnectionStatus(roomId, peerId, videoId, mediaType, state) {
    const isConnected = state == this.CONNECTION_STATES.Connected;
    EventEmitter.emit("connectionChange", {
      roomId,
      peerId,
      videoId,
      mediaType,
      state: isConnected
    });
  }
}
